import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  providerBankListRequest: ["filters", "options"],
  providerBanksCountRequest: ["filters"],

  providerBankListSuccess: ["providerBankList"],
  providerBanksCountSuccess: ["count"],

  providerBankListFailure: ["error"],
  providerBanksCountFailure: ["error"],

  paystackReveknewBankUpdateRequest: ["payload"],
  paystackReveknewBankUpdateSuccess: ["result"],
  paystackReveknewBankUpdateFailure: ["error"],
  paystackReveknewBankUpdateReset: [],
});

export const ProviderBankTypes = Types;
export default Creators;
